import { render, staticRenderFns } from "./changelog-dialog.vue?vue&type=template&id=59865ea0"
import script from "./changelog-dialog.vue?vue&type=script&lang=js"
export * from "./changelog-dialog.vue?vue&type=script&lang=js"
import style0 from "./changelog-dialog.vue?vue&type=style&index=0&id=59865ea0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports